export const translations = {
  en: {
    appName: 'Guningo',
    tagline: 'Safar karo, paise bachao',
    shareRides: "India's favourite ride sharing app",
    findARide: 'Find a Ride',
    postARide: 'Post a Ride',
    myBookings: 'My Bookings',
    profile: 'Profile',
    notifications: 'Notifications',
    ratings: 'Ratings',
    earnings: 'Earnings',
    feedback: 'Feedback',
    logout: 'Logout',
    from: 'From',
    to: 'To',
    today: 'Today',
    tomorrow: 'Tomorrow',
    sortByPrice: 'Sort: Price',
    sortByTime: 'Sort: Time',
    bookThisRide: 'Book this ride',
    seatsLeft: 'seats left',
    perSeat: 'per seat',
    noRidesFound: 'No matching rides found',
    ridesPosted: 'rides posted on Guningo',
    bookingDetails: 'Booking Details',
    driverInformation: 'Driver Information',
    selectSeats: 'Select Seats',
    totalAmount: 'Total Amount',
    requestBooking: 'Request Booking',
    seatsAvailable: 'seats available',
    save: 'Save Changes',
    editProfile: 'Edit Profile',
    fullName: 'Full Name',
    city: 'City',
    vehicle: 'Vehicle',
    documents: 'Documents',
    routeDetails: 'Route details',
    departureCity: 'Departure city',
    destinationCity: 'Destination city',
    travelDate: 'Travel date',
    departureTime: 'Departure time',
    availableSeats: 'Available seats',
    pricePerSeat: 'Price per seat',
    postRide: 'Post ride on Guningo',
    typeMessage: 'Type a message...',
    liveTracking: 'Live Tracking',
    startTracking: 'Start tracking',
    stopTracking: 'Stop tracking',
    rateYourRide: 'Rate your ride',
    submitRating: 'Submit rating',
    myEarnings: 'My Earnings',
    withdraw: 'Withdraw',
    skip: 'Skip for now',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account? Login',
    welcomeBack: 'Welcome back!',
    sendOtp: 'Send OTP',
    enterOtp: 'Enter OTP',
  },
  hi: {
    appName: 'गुनिंगो',
    tagline: 'सफर करो, पैसे बचाओ',
    shareRides: 'भारत का पसंदीदा राइड शेयरिंग ऐप',
    findARide: 'राइड खोजें',
    postARide: 'राइड पोस्ट करें',
    myBookings: 'मेरी बुकिंग',
    profile: 'प्रोफाइल',
    notifications: 'सूचनाएं',
    ratings: 'रेटिंग्स',
    earnings: 'कमाई',
    feedback: 'प्रतिक्रिया',
    logout: 'लॉगआउट',
    from: 'कहाँ से',
    to: 'कहाँ तक',
    today: 'आज',
    tomorrow: 'कल',
    sortByPrice: 'क्रमबद्ध करें: कीमत',
    sortByTime: 'क्रमबद्ध करें: समय',
    bookThisRide: 'यह राइड बुक करें',
    seatsLeft: 'सीटें बाकी',
    perSeat: 'प्रति सीट',
    noRidesFound: 'कोई राइड नहीं मिली',
    ridesPosted: 'राइड गुनिंगो पर पोस्ट की गई',
    bookingDetails: 'बुकिंग विवरण',
    driverInformation: 'ड्राइवर की जानकारी',
    selectSeats: 'सीटें चुनें',
    totalAmount: 'कुल राशि',
    requestBooking: 'बुकिंग का अनुरोध करें',
    seatsAvailable: 'सीटें उपलब्ध',
    save: 'बदलाव सहेजें',
    editProfile: 'प्रोफाइल संपादित करें',
    fullName: 'पूरा नाम',
    city: 'शहर',
    vehicle: 'वाहन',
    documents: 'दस्तावेज़',
    routeDetails: 'रास्ते का विवरण',
    departureCity: 'प्रस्थान शहर',
    destinationCity: 'गंतव्य शहर',
    travelDate: 'यात्रा की तारीख',
    departureTime: 'प्रस्थान समय',
    availableSeats: 'उपलब्ध सीटें',
    pricePerSeat: 'प्रति सीट कीमत',
    postRide: 'गुनिंगो पर राइड पोस्ट करें',
    typeMessage: 'संदेश लिखें...',
    liveTracking: 'लाइव ट्रैकिंग',
    startTracking: 'ट्रैकिंग शुरू करें',
    stopTracking: 'ट्रैकिंग रोकें',
    rateYourRide: 'अपनी राइड को रेट करें',
    submitRating: 'रेटिंग सबमिट करें',
    myEarnings: 'मेरी कमाई',
    withdraw: 'निकालें',
    skip: 'अभी छोड़ें',
    createAccount: 'खाता बनाएं',
    alreadyHaveAccount: 'पहले से खाता है? लॉगिन करें',
    welcomeBack: 'वापसी पर स्वागत है!',
    sendOtp: 'ओटीपी भेजें',
    enterOtp: 'ओटीपी दर्ज करें',
  },
};